import { clickAsLink } from 'helpers/link_helpers';

export function goToCompShow(clickEvent, comp) {
  return (_, getState) => {
    const edgeCrm = getState().features.edgeCrm;
    if (edgeCrm) {
      clickAsLink(window, comp.path, clickEvent);
      return;
    }

    const allPropertiesIds = getState().search.meta.compIds;

    const offset = allPropertiesIds.findIndex(num => num == comp.id);
    const href = `${comp.showPath}?offset=${offset}`;

    if (comp.showPath && href) {
      clickAsLink(window, href, clickEvent);
    }
  };
}